import { clsx } from 'clsx';
import { FC } from 'react';
import { Types, Text, Eyebrow, Label } from '@marriott/mi-ui-library';
import { StyledAwardsGalleryRow } from './AwardsGalleryRow.styles';
import { AwardListProps, AwardTileProps, AwardsGalleryRowProps } from './AwardsGalleryRow.types';

export const AwardsGalleryRow: FC<AwardsGalleryRowProps> = (props: AwardsGalleryRowProps) => {
  const { allAwardsList, variation, year } = props;

  const awardContentClass = variation === '1' || variation === '2' ? 'px-md-5' : 'px-md-0';

  const getColumnClass = () => {
    if (variation === '1') return 'col-12';
    if (variation === '2') return 'col-6 award-gallery-seperator award-gallery-seperator-even';
    return 'col-4 award-gallery-seperator award-gallery-seperator-odd';
  };

  const rowBottomSpacing = variation === '2' || variation === '3' ? 'pb-md-4 pb-3 pb-md-0' : '';

  return (
    <StyledAwardsGalleryRow>
      <div className="d-flex justify-content-center text-center pt-0 pb-md-5 pb-3 mx-auto mb-lg-2">
        <div className="award-gallery-year-border mt-2 mx-5" />
        <Eyebrow text={year} />
        <div className="award-gallery-year-border mt-2 mx-5" />
      </div>

      <div className={clsx('row', rowBottomSpacing)}>
        {allAwardsList.length > 0 &&
          allAwardsList.map((eachColumnAwards: AwardListProps, index: number) => {
            const listOfAwards = eachColumnAwards.awardDetailsList;
            const hasAwards = listOfAwards && listOfAwards.length > 0;

            return (
              <div className={getColumnClass()} key={`column-${eachColumnAwards.columnNumber}-${index}`}>
                {hasAwards ? (
                  listOfAwards.map((eachAward: AwardTileProps, awardIndex: number) => {
                    const { awardTitle, awardDescription } = eachAward;
                    return (
                      <div
                        className={clsx(awardContentClass, 'mx-md-3 mx-0 px-0 pb-5 mb-lg-3')}
                        key={`award-${awardTitle}-${awardIndex}`}
                      >
                        <Label
                          labelText={awardTitle}
                          element={Types.tags.div}
                          variation={Types.TypographyColorVariations.Alternate}
                          size={Types.size.small}
                          customClass="text-center"
                        />
                        <Text
                          copyText={awardDescription}
                          fontSize={Types.size.small}
                          element={Types.tags.div}
                          customClass="text-center mt-2 mx-0"
                        />
                      </div>
                    );
                  })
                ) : (
                  <div aria-hidden="true" />
                )}
              </div>
            );
          })}
      </div>
    </StyledAwardsGalleryRow>
  );
};

AwardsGalleryRow.displayName = 'AwardsGalleryRow';
